import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { MESSAGE_TOAST } from 'src/app/shared/enums/message-toast-enum';
import { ProfileService } from 'src/app/shared/service/profile.service';
import { Spinner } from './../../../../../core/services/spinner.service';
import { ConfirmationDialogComponent } from './../../../../../shared/components/dialog/confirmation-dialog.component';
import { CustomValidator } from './../../../../../shared/directive/custom-validator';
import { TicketRequest } from './../../../../../shared/model/ticket-access-request.model';
import { PortalScorecardService } from './../../../../../shared/service/portal-scorecard.service';
import { DialogSearchSSOComponent } from '../quality-suites-form/searchSSO/search-SSO.component';

@Component({
  selector: 'app-suppiler-portal-scorecard',
  templateUrl: './suppiler-portal-scorecard.component.html',
  styleUrls: ['./suppiler-portal-scorecard.component.scss']
})
export class SuppilerPortalScorecardComponent implements OnInit {

  scorecardForm: FormGroup;
  externalForm: FormGroup;
  request: TicketRequest[] = [];
  userName: string;
  fullName: string;
  isRSPBusiness: boolean = false;
  ssoDialogRef: MatDialogRef<DialogSearchSSOComponent>;
  businesses = ['SRM Access', 'Supplier Portal access'];

  width: number = window.innerWidth;

  constructor(
    private spinner: Spinner,
    private profileService: ProfileService,
    private scorecardService: PortalScorecardService,
    private toastrService: ToastrService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.initForm();
    this.getUserInfo();
    this.getListTicket();
  }

  public initForm() {
    this.scorecardForm = new FormGroup({
      userName: new FormControl(this.userName || '', [CustomValidator.required]),
      fullName: new FormControl(this.fullName || '', [CustomValidator.required]),
      geContactSso: new FormControl('', [CustomValidator.required]),
      purchaseOrder: new FormControl('', [CustomValidator.required]),
      supplierGSL: new FormControl('', [CustomValidator.required]),
      srmToken: new FormControl('', [CustomValidator.required]),
      business: new FormControl(this.businesses[0], [CustomValidator.required]),
      email: new FormControl('', [CustomValidator.required]),
    });
    this.scorecardForm.controls.email.setValue('N/A');
  }

  public getUserInfo() {
    this.spinner.show();
    this.profileService.getProfileUser().subscribe((res: any) => {
      this.spinner.hide();
      if (res.data) {
        this.userName = res.data.sso;
        this.fullName = res.data.fullName;
        this.initForm();
      }
    });
  }

  public submit() {
    if (this.scorecardForm.invalid) {
      this.markFormGroupTouched(this.scorecardForm);
      return;
    }

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: MESSAGE_TOAST.CONFIRM_REQUEST_ACCESS,
        buttonText: {
          ok: 'Yes',
          cancel: 'No'
        }
      }
    });
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm) {
        this.spinner.show();
        this.scorecardService.createRequestAccess(this.scorecardForm.getRawValue()).subscribe((res: any) => {
          this.spinner.hide();
          if (res.status === 200) {
            this.toastrService.success(MESSAGE_TOAST.REQUEST_ACCESS_TICKET_SUCCESS);
            setTimeout(() => {
              location.reload();
            }, 1000);
          }
        });
      }
    });


  }

  private markFormGroupTouched(formGroup: FormGroup): void {
    (Object as any).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  public goToApplication() {
    window.open('https://supplierportal.wind.apps.gevernova.com/srm/home-page');
  }

  public getListTicket(event?) {
    if (event) {
      event.srcElement.classList.remove('rotate');
      setTimeout(() => {
        event.srcElement.classList.add('rotate');
      }, 0);
    }
    this.scorecardService.getRequestSupplierPortalScorecard().subscribe(res => {
      if (res.data.length > 0) {
        this.request = res.data;
      }
    });
  }

  selectBusiness($event) {
    this.isRSPBusiness = this.scorecardForm.controls.business.value === 'Supplier Portal access';
    if (this.isRSPBusiness) {
      this.scorecardForm.controls.supplierGSL.setValue('N/A');
      this.scorecardForm.controls.srmToken.setValue('N/A');
      this.scorecardForm.controls.purchaseOrder.setValue('N/A');
      this.scorecardForm.controls.email.setValue('');
    } else {
      this.scorecardForm.controls.purchaseOrder.setValue('');
      this.scorecardForm.controls.supplierGSL.setValue('');
      this.scorecardForm.controls.srmToken.setValue('');
      this.scorecardForm.controls.email.setValue('N/A');
    }
  }

  searchSSO(event) {
    this.ssoDialogRef = this.dialog.open(DialogSearchSSOComponent, {
      width: this.width > 1000 ? '40%' : '100%',
      maxWidth: '100%',
      maxHeight: '500px',
      data: {}
    });
    this.ssoDialogRef.afterClosed().pipe(
    ).subscribe(result => {
      console.log(result);
      this.scorecardForm.controls.geContactSso.setValue(result.name);
    });
  }
}
